import e from './style.module.css';


type ButtonType ={
  type: "button" | "submit" | "reset", 
  className?: string,
  value: string,
  onClick?: () => void,
  disabled?: boolean,
  showLoading?: boolean,
  icon?: string
}

type BtnImgType = ButtonType &{
  width: string
}

// boton con texto dentro
export default function Button ({ type, className, value, onClick, disabled = false, showLoading, icon }:ButtonType) {
  return (
    <button
      type={type}
      className={`${className} ${e.btn}`}
      onClick={onClick}
      disabled={disabled}      
      >{value} {((showLoading && icon && !disabled) || (!showLoading && icon)) && <i className={`bi ${icon}`}></i>} {(disabled && showLoading) && <span className="spinner-border spinner-border-sm" aria-hidden="true"></span>}
    </button>
  )
}

// boton con imagen dentro
export function ButtonImg ({ type, className, value, onClick, width }:BtnImgType) {
  return (
    <button
      type={type}
      className={`shadow ${className} ${e.btn}`}
      onClick={onClick}
    ><img src={value} alt='' width={width} />
    </button>
  )
}